export enum CheckState {
  uncheck,
  partial,
  check
}
